<!--
  - Copyright (c) 2022.
  -
  - Unless required by applicable law or agreed to in writing, software
  - distributed under the License is distributed on an "AS IS" BASIS,
  - WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  - See the License for the specific language governing permissions and
  - limitations under the License.
  -
  -->

<template>
    <div>
        <van-nav-bar
            title="我的体检报告"
            left-arrow
            @click-left="$router.go(-1)"
        >
        </van-nav-bar>

        <van-empty v-if="list.length === 0 && !loading" description="您没有体检记录">
        </van-empty>

        <van-list
            v-model="loading"
            :finished="finished"
            :immediate-check="false"
            loading-text='正在加载...'
            @load="onLoad"
        >
            <van-cell class="my-cell" center v-for="item in list" :title="item.productName" :label="item.testDate"
                      :to="buildReportUrl(item)">
                <template #label>
                    <div>
                        <div>受检人: {{ item.tester.name }} {{item.tester.mobile}}</div>
                        <div>预约日期: {{ item.testDateTimeString }}</div>
                    </div>
                </template>
                <template #default>
                    <div><van-tag size="large" :color="item.statusColor">{{ item.statusName }}</van-tag></div>
                </template>
            </van-cell>
        </van-list>
    </div>
</template>

<script>
import http from "@/utils/http";
import qs from "qs";
import moment from "moment";

export default {
    name: "MyTesterReport",
    data() {
        return {
            spinShow: false,
            loading: false,
            finished: false,
            keywords: '',
            item: {},
            list: [],
            status: 0,
        };
    },
    mounted() {
        this.loadList();
    },
    watch: {
        status: function(value) {
            this.list = [];
            this.loadList();
        }
    },
    methods: {
        onLoad() {
            this.loadList();
        },
        buildReportUrl(item) {
            if(!item.report0) {
                return;
            }
            // var urls = ['/api/personal/tester_report_'+item.report0];
            // if(item.report1){
            //     urls.push('/api/personal/tester_report_'+item.report1)
            // }
            // if(item.report2){
            //     urls.push('/api/personal/tester_report_'+item.report2)
            // }
            var urls = [item.report0];
            if(item.report1){
                urls.push(item.report1)
            }
            if(item.report2){
                urls.push(item.report2)
            }
            if(item.report3){
                urls.push(item.report3)
            }
            if(item.report4){
                urls.push(item.report4)
            }
            if(urls.length === 1) {
                return '/downloads?title=体检报告'+item.id+'&urls='+encodeURIComponent(urls[0]);
                // return '/pdf?title=体检报告'+item.id+'&url='+encodeURIComponent(urls[0]);,,
            }
            return '/downloads?title=体检报告'+item.id+'&urls='+encodeURIComponent(urls.join(","));
            // return '/pdfs?title=体检报告'+item.id+'&urls='+encodeURIComponent(urls.join(","));
        },
        loadList: function () {
            var filter =  JSON.stringify({status: '0'});
            var payload = {start: this.list.length, limit: 10, keywords: '', filter: filter};
            // console.log(payload)
            this.loading = true;
            http.post('/api/personal/list_appointments', qs.stringify(payload))
                .then(response => {
                    // console.log(response.data)
                    this.loading = false;
                    if (!response.data.result) {
                        this.finished = true;
                    } else {
                        if (response.data.extra.items.length === 0) {
                            this.finished = true;
                        } else {
                            var items = response.data.extra.items;
                            items.forEach(appointment => {
                                appointment.tester = JSON.parse(appointment.testerDesc);
                                var testDate = moment(appointment.testDate);
                                appointment.testDateTimeString = testDate.format("YYYY年M月D日") + ' 星期' + '日一二三四五六'.charAt(testDate.day()) + ' ' + testDate.format("HH:mm");

                                var statusColor = appointment.report0?'#0CC160':'#B2B3B0';
                                var statusName = appointment.report0?'已开具':'待开具';
                                appointment.statusColor = statusColor;
                                appointment.statusName = statusName;
                            });
                            // console.log(items)
                            this.list.push(...items);
                        }
                    }
                })
                .catch(error => {
                    // console.error(error)
                    this.loading = false;
                    this.finished = true;
                });
        },
    },
}
</script>

<style scoped>
    .my-cell .van-cell__title {
        flex: 2;
    }
</style>